export function resolveSitePublicUrl(item) {
  if (!item) return null;
  if (item.publicUrl) return item.publicUrl;
  if (item.publicHost) {
    return `https://${String(item.publicHost).replace(/^https?:\/\//, '')}`;
  }
  return null;
}

export function openSitePublicUrl(item, e) {
  const url = resolveSitePublicUrl(item);
  if (!url) return false;
  const target = e && (e.metaKey || e.ctrlKey || e.button === 1) ? '_blank' : '_blank';
  window.open(url, target, 'noopener,noreferrer');
  return true;
}
